export const StopIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2040_490)">
      <path d="M4.5 4H12.5V12H4.5V4Z" />
    </g>
    <defs>
      <clipPath id="clip0_2040_490">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
